import { render, staticRenderFns } from "./basicaddressform.vue?vue&type=template&id=a69c6e94"
import script from "./basicaddressform.vue?vue&type=script&lang=js"
export * from "./basicaddressform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports